import { get } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import { SETTINGS_BANNERS } from '../constants/apiTypes';
import { API_CALL_SUCCESS, TOGGLE_DARK_MODE } from '../constants/actionTypes';
import config from '../config';

const initialState = {
  ...config.settings
};

const normaliseBanners = data =>
  data.map(
    ({ desktop: desktopSrc, is_public: isPublic, mobile: mobileSrc, redirect_url: link }) => ({
      isPublic: !!isPublic,
      link,
      desktopSrc,
      mobileSrc
    })
  );

export default createReducer(initialState, {
  [API_CALL_SUCCESS]: (state, { data = [], meta = {}, api }) => {
    const newState = get('currency', meta)
      ? {
          currency: meta.currency
        }
      : {};

    switch (api) {
      case SETTINGS_BANNERS:
        newState.promo = Array.isArray(data) && data.length > 0 ? normaliseBanners(data) : [];
        break;
      default:
    }

    return newState;
  },
  [TOGGLE_DARK_MODE]: (state, action) => ({
    darkMode: action.darkMode
  })
});
